export default __webpack_public_path__ + "static/media/ViveLeVent.b29cfa4e.mp3";